module.exports = __webpack_public_path__ + "img/17.f8560a4d.png";